export const CLASS_FILTER_DEFAULT_START_TIME = 5;
export const CLASS_FILTER_DEFAULT_END_TIME = 22;

export interface FilterModel {
    AddressIds: number[];
    StudioIds: number[];
    InstructorIds: number[];
    LocationId: number;
    StartTime: number;
    EndTime: number;
    /**
     * Serialized schedule location selection.
     * Empty: host only (default; existing URLs with no `partner` param).
     * `host,partnerKey,...`: host plus those partners.
     * `partnerKey,...` without the `host` token: those partners only.
     */
    PartnerKey: string;
}

export function createDefaultFilterModel(): FilterModel {
    return {
        AddressIds: [],
        StudioIds: [],
        InstructorIds: [],
        LocationId: 0,
        StartTime: CLASS_FILTER_DEFAULT_START_TIME,
        EndTime: CLASS_FILTER_DEFAULT_END_TIME,
        PartnerKey: '',
    };
}